import 'twin.macro'

import React, { FC } from 'react'
import tw, { TwStyle } from 'twin.macro'
type TitleProps = {
  children: React.ReactNode
  variant?: 'bold' | 'regular'
  twStyle?: TwStyle
  className?: string
}
const textVariants = {
  bold: tw`font-bold`,
  regular: tw`font-normal`
} as { bold: TwStyle; regular: TwStyle }

const styles = {
  text: ({ variant = 'regular', twStyle }: { variant?: 'bold' | 'regular'; twStyle?: TwStyle }) => [
    tw`lg:text-[22px] md:text-[20px] text-s24`,
    textVariants[variant],
    twStyle
  ]
}

export const Title: FC<TitleProps> = ({ children, variant, twStyle, className }) => {
  return (
    <h2 className={className} css={styles.text({ variant, twStyle })}>
      {children}
    </h2>
  )
}
export default Title
